namespace TabAurous.HR {
    export interface HolidaysRow {
        HolidayId?: number;
        Date?: string;
        HolidayName?: string;
        Narration?: string;
        HolidayListId?: number;
    }

    export namespace HolidaysRow {
        export const idProperty = 'HolidayId';
        export const nameProperty = 'HolidayName';
        export const localTextPrefix = 'HR.Holidays';
        export const deletePermission = 'HR:HolidayList:Delete';
        export const insertPermission = 'HR:HolidayList:Add';
        export const readPermission = '*';
        export const updatePermission = 'HR:HolidayList:Edit';

        export declare const enum Fields {
            HolidayId = "HolidayId",
            Date = "Date",
            HolidayName = "HolidayName",
            Narration = "Narration",
            HolidayListId = "HolidayListId"
        }
    }
}
